import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import Actions from './utils/actions'

const RESOURCE_NAME = 'flexibilidade'

const endpoint = (action, id) => {
  switch (action) {
    case Actions.INDEX:
    case Actions.CREATE:
      return `/acl/contratos/${id}/flexibilidades`

    case Actions.SHOW:
    case Actions.UPDATE:
    case Actions.DESTROY:
      return `/acl/flexibilidades/${id}`

    default:
      return ''
  }
}

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingFlexibilidadeSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingFlexibilidadeSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_FLEXIBILIDADE_SUCCESS = 'LOADING_FLEXIBILIDADE_SUCCESS'
export function loadingFlexibilidadeSuccess(flexibilidade) {
  return {
    type: LOADING_FLEXIBILIDADE_SUCCESS,
    flexibilidade,
  }
}

export const DESTROYING_FLEXIBILIDADE_SUCCESS =
  'DESTROYING_FLEXIBILIDADE_SUCCESS'
export function destroyingFlexibilidadeSuccess(flexibilidadeId) {
  return {
    type: DESTROYING_FLEXIBILIDADE_SUCCESS,
    flexibilidadeId,
  }
}

export function fetchMultipleFlexibilidade(parentId) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.INDEX, parentId)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchFlexibilidade(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.SHOW, id)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createFlexibilidade(parentId, flexibilidade) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(
      endpoint(Actions.CREATE, parentId),
      'POST',
      flexibilidade
    ).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateFlexibilidade(id, flexibilidade) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.UPDATE, id), 'PUT', flexibilidade).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyFlexibilidade(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(endpoint(Actions.DESTROY, id), 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

const flexibilidade = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_FLEXIBILIDADE_SUCCESS: {
      const { flexibilidade: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_FLEXIBILIDADE_SUCCESS:
      return state.delete(action.flexibilidadeId.toString())

    default:
      return state
  }
}

export default flexibilidade
